import { render } from '@verndale/core';
import Input from './modules/input';
import Modal from './components/modal';

export const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { createRoot } = require('react-dom/client');
  return nodeList.forEach(node =>
    createRoot(node).render(<Component {...node.dataset} />)
  );
};

const instantiateModule = (elements, Module) => render(elements, el => new Module(el));

const modules = [
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'quick-access-card',
    loader: () => import('./modules/quick-access-card')
  },
  {
    name: 'quick-access',
    loader: () => import('./modules/quick-access')
  },
  {
    name: 'community-nav-row',
    loader: () => import('./modules/community-nav-row')
  },
  {
    name: 'community-landing-masthead',
    loader: () => import('./modules/community-landing-masthead')
  },
  {
    name: 'related-resources',
    loader: () => import('./modules/related-resources')
  },
  {
    name: 'leadership-update-intro',
    loader: () => import('./modules/leadership-update-intro')
  },
  {
    name: 'resource-detail-intro',
    loader: () => import('./modules/resource-detail-intro')
  },
  {
    name: 'quick-access-media',
    loader: () => import('./modules/quick-access-media')
  },
  {
    name: 'two-tabs-masthead-extension',
    loader: () => import('./modules/two-tabs-masthead-extension')
  },
  {
    name: 'community-contact-us',
    loader: () => import('./modules/community-contact-us')
  },
  {
    name: 'share-communities',
    loader: () => import('./modules/share-communities')
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'form',
    loader: () => import('./modules/form')
  },
  {
    name: 'footer',
    loader: () => import('./modules/footer')
  },
  {
    name: 'monogram-header',
    loader: () => import('./modules/monogram-header')
  },
  {
    name: 'monogram-footer',
    loader: () => import('./modules/monogram-footer')
  },
  {
    name: 'tabs',
    loader: () => import('./modules/tabs')
  },
  {
    name: 'cluster-communities-map-row-headless',
    loader: () => import('./coveo/modules/ClusterCommunitiesMapRow'),
    render: reactModule
  },
  {
    name: 'gallery-row',
    loader: () => import('./modules/gallery-row')
  },
  {
    name: 'leadership-row',
    loader: () => import('./modules/leadership-row')
  },
  {
    name: 'community-calendar-row',
    loader: () => import('./modules/community-calendar-row')
  },
  {
    name: 'community-awards',
    loader: () => import('./modules/community-awards')
  },
  {
    name: 'compare-communities-row',
    loader: () => import('./modules/compare-communities-row')
  },
  {
    name: 'community-testimonial-row',
    loader: () => import('./modules/community-testimonial-row')
  },
  {
    name: 'floor-plans-row',
    loader: () => import('./modules/floor-plans-row')
  },
  {
    name: 'virtual-tour-row',
    loader: () => import('./modules/virtual-tour-row')
  },
  {
    name: 'careers-header',
    loader: () => import('./modules/careers-header')
  },
  {
    name: 'careers-search-bar',
    loader: () => import('./modules/careers-search-bar')
  },
  {
    name: 'alert',
    loader: () => import('./components/alert')
  },
  {
    name: 'video',
    loader: () => import('./components/video')
  },
  {
    name: 'community-alert-banner',
    loader: () => import('./modules/community-alert-banner')
  },
  {
    name: 'dropdown',
    loader: () => import('./components/dropdown')
  },
  {
    name: 'faqs-container',
    loader: () => import('./modules/faqs-container')
  },
  {
    name: 'community-contact-us-headless',
    loader: () => import('./coveo/modules/CommunityContactUs'),
    render: reactModule
  },
  {
    name: 'nearby-communities-row-headless',
    loader: () => import('./coveo/modules/NearbyCommunitiesRow'),
    render: reactModule
  },
  {
    name: 'coveo-search-input-headless',
    loader: () => import('./coveo/components/CoveoSearchInput'),
    render: reactModule
  },
  {
    name: 'masthead-with-zipcode-headless',
    loader: () => import('./coveo/modules/MastheadWithZipCode'),
    render: reactModule
  },
  // {
  //   name: 'community-search-row-headless',
  //   loader: () => import('./coveo/modules/CommunitySearchRow'),
  //   render: reactModule
  // },
  {
    name: 'nearby-communities-supporting-column-headless',
    loader: () => import('./coveo/modules/NearbyCommunitiesSupportingColumn'),
    render: reactModule
  },
  {
    name: 'share-communities-headless',
    loader: () => import('./coveo/modules/ShareCommunities'),
    render: reactModule
  },
  {
    name: 'header-search-headless',
    loader: () => import('./coveo/modules/HeaderSearch'),
    render: reactModule
  },
  {
    name: 'targeted-campaign-map-row-headless',
    loader: () => import('./coveo/modules/TargetedCampaignMapRow'),
    render: reactModule
  },
  {
    name: 'search-list-row',
    loader: () => import('./modules/search-list-row')
  },
  {
    name: 'resource-listing-row',
    loader: () => import('./modules/resource-listing-row')
  },
  {
    name: 'nearby-communities-row',
    loader: () => import('./modules/nearby-communities-row')
  },
  {
    name: 'nearby-communities-row-with-search',
    loader: () => import('./modules/nearby-communities-row-with-search')
  },
  {
    name: 'homepage-masthead',
    loader: () => import('./modules/homepage-masthead')
  },
  {
    name: 'masthead-with-zipcode',
    loader: () => import('./modules/masthead-with-zipcode')
  },
  {
    name: 'location-selector',
    loader: () => import('./components/location-selector')
  },
  {
    name: 'find-a-community-zipcode-map-and-results-headless',
    loader: () => import('./coveo/modules/FindACommunityZipCodeMapAndResults'),
    render: reactModule
  },
  {
    name: 'location-selector-headless',
    loader: () => import('./coveo/modules/LocationSelector'),
    render: reactModule
  },
  {
    name: 'resources-listing-row-headless',
    loader: () => import('./coveo/modules/ResourcesListingRow'),
    render: reactModule
  },
  {
    name: 'search-listing-row-headless',
    loader: () => import('./coveo/modules/SearchListingRow'),
    render: reactModule
  },
  {
    name: 'national-campaign-map-row-headless',
    loader: () => import('./coveo/modules/NationalCampaignMapRow'),
    render: reactModule
  },
  {
    name: 'communities-supporting-column',
    loader: () => import('./modules/communities-supporting-column')
  },
  {
    name: 'national-campaign-map-row',
    loader: () => import('./modules/national-campaign-map-row')
  },
  {
    name: 'targeted-campaign-map-row',
    loader: () => import('./modules/targeted-campaign-map-row')
  },
  {
    name: 'community-landing-about',
    loader: () => import('./modules/community-landing-about')
  },
  {
    name: 'masthead-common-content',
    loader: () => import('./components/masthead-common-content')
  },
  {
    name: 'resource-landing-masthead',
    loader: () => import('./modules/resource-landing-masthead')
  },
  {
    name: 'mls-listing',
    loader: () => import('./modules/mls-listing')
  },
  {
    name: 'share-addthis',
    loader: () => import('./modules/share-addthis')
  },
  {
    name: 'podcast',
    loader: () => import('./modules/podcast')
  },
  {
    name: 'community-row',
    loader: () => import('./modules/community-row')
  },
  {
    name: 'blog-teaser',
    loader: () => import('./modules/blog-teaser')
  },
  {
    name: 'monogram-community-landing-masthead',
    loader: () => import('./modules/monogram-community-landing-masthead')
  }
];

export function global() {
  const $modals = document._$$('.modal');
  const $inputFields = document.querySelectorAll('.field__input');
  const $selectFields = document.querySelectorAll('.field__select');

  instantiateModule($inputFields, Input);
  instantiateModule($selectFields, Input);
  instantiateModule($modals, Modal);
}

export default [...modules];
